import React from "react";

import * as RadixSelect from "@radix-ui/react-select";

import {
  CaretDownIcon,
  PersonSimpleWalkIcon,
  CarIcon,
  BicycleIcon,
} from "@phosphor-icons/react";

import type { TravelMode } from "~/sdks/LocalContent/hooks/useCommute/types";

import { useTranslation } from "react-i18next";

import * as styles from "./styles";

const options = ["walking", "driving", "cycling"] as TravelMode[];
const icons = {
  walking: <PersonSimpleWalkIcon size={16} />,
  driving: <CarIcon size={16} />,
  cycling: <BicycleIcon size={16} />,
};

export interface SelectProps {
  name: string;
  selected?: TravelMode;
  isOpen?: boolean;
  onChange: (value: TravelMode) => void;
  disabled?: boolean;
  placeholder?: string;
}

export const Select = ({
  name,
  selected = options[0],
  onChange,
  disabled,
}: SelectProps) => {
  const { t } = useTranslation("localContent");

  return (
    <RadixSelect.Root
      value={selected}
      onValueChange={(value: string) => onChange(value as TravelMode)}
    >
      <RadixSelect.Trigger
        id={name}
        data-testid={`select-${name}`}
        className={styles.trigger}
        disabled={disabled}
      >
        <span className={styles.selected}>
          {icons[selected]}
          <RadixSelect.Value
            placeholder={t(`commute.travelTypes.${selected}`)}
          />
        </span>
        <RadixSelect.Icon asChild>
          <CaretDownIcon className={styles.icon} size={20} />
        </RadixSelect.Icon>
      </RadixSelect.Trigger>

      <RadixSelect.Content
        className={styles.content}
        align="start"
        sticky="always"
      >
        <RadixSelect.Viewport className={styles.contentViewport}>
          <>
            {options.map((value) => (
              <RadixSelect.Item
                className={styles.item}
                key={value}
                value={value}
              >
                <RadixSelect.Icon>{icons[value]}</RadixSelect.Icon>

                <RadixSelect.ItemText>
                  {t(`commute.travelTypes.${value}`)}
                </RadixSelect.ItemText>
              </RadixSelect.Item>
            ))}
          </>
        </RadixSelect.Viewport>
      </RadixSelect.Content>
    </RadixSelect.Root>
  );
};
